var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PanelList',{staticClass:"mt-3",attrs:{"items":_vm.warehouseItems,"title":"المستودع","noDelete":"","canSelectAll":false}},_vm._l((_vm.warehouseItems || []),function(warehouseItem,i){return _c('WarehouseItemPanelItem',{key:i,attrs:{"warehouseItem":warehouseItem}})}),1),_c('WarehouseItemModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }